import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as historyApi from "@api/history.api";
import type { ScraperHistory } from "@/types";

interface HistoryState {
  items: ScraperHistory[];
  total: number;
  recentActivity: ScraperHistory[];
  loading: boolean;
}

const initialState: HistoryState = {
  items: [],
  total: 0,
  recentActivity: [],
  loading: false,
};

export const fetchHistory = createAsyncThunk(
  "history/fetchAll",
  async (params?: { scraperId?: string; limit?: number; offset?: number }) => {
    return await historyApi.getAll(
      params?.scraperId,
      params?.limit,
      params?.offset,
    );
  },
);

export const fetchRecentActivity = createAsyncThunk(
  "history/fetchRecent",
  async (limit?: number) => {
    return await historyApi.getRecent(limit);
  },
);

export const clearHistory = createAsyncThunk(
  "history/clear",
  async (scraperId?: string) => {
    await historyApi.clearHistory(scraperId);
    return scraperId;
  },
);

const historySlice = createSlice({
  name: "history",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.items = action.payload.items;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(fetchHistory.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchRecentActivity.fulfilled, (state, action) => {
        state.recentActivity = action.payload;
      })
      .addCase(clearHistory.fulfilled, (state, action) => {
        if (action.payload) {
          state.items = state.items.filter(
            (i) => i.scraperId !== action.payload,
          );
        } else {
          state.items = [];
          state.total = 0;
        }
      });
  },
});

export default historySlice.reducer;
